const prepareFilterParams = (filters, rowsPerPage, page) => {
  const result = { size: rowsPerPage, page };

  if (filters.company?.companyId) result['companyId.equals'] = filters.company?.companyId;

  if (filters.dateFrom) result['payDate.greaterThanOrEqual'] = filters.dateFrom;

  if (filters.dateTo) result['payDate.lessThan'] = filters.dateTo;

  if (filters.type) result['type.equals'] = filters.type;

  return result;
};

export default prepareFilterParams;
